define(['exports', 'react', 'classnames', 'lodash', '../../i18n', '../utils', '../utils/appConstants', '../../assets/correct.svg', '../../assets/wrong.svg', 'material-ui', '../common/ToolTipComponent', './ReportSectionsWrapperInfo', './styles/CandidateReportsView.css'], function (exports, _react, _classnames, _lodash, _i18n, _utils, _appConstants, _correct, _wrong, _materialUi, _ToolTipComponent, _ReportSectionsWrapperInfo) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _i18n2 = _interopRequireDefault(_i18n);

	var appConstants = _interopRequireWildcard(_appConstants);

	var _correct2 = _interopRequireDefault(_correct);

	var _wrong2 = _interopRequireDefault(_wrong);

	var _ToolTipComponent2 = _interopRequireDefault(_ToolTipComponent);

	var _ReportSectionsWrapperInfo2 = _interopRequireDefault(_ReportSectionsWrapperInfo);

	function _interopRequireWildcard(obj) {
		if (obj && obj.__esModule) {
			return obj;
		} else {
			var newObj = {};

			if (obj != null) {
				for (var key in obj) {
					if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
				}
			}

			newObj.default = obj;
			return newObj;
		}
	}

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	var _get = function get(object, property, receiver) {
		if (object === null) object = Function.prototype;
		var desc = Object.getOwnPropertyDescriptor(object, property);

		if (desc === undefined) {
			var parent = Object.getPrototypeOf(object);

			if (parent === null) {
				return undefined;
			} else {
				return get(parent, property, receiver);
			}
		} else if ("value" in desc) {
			return desc.value;
		} else {
			var getter = desc.get;

			if (getter === undefined) {
				return undefined;
			}

			return getter.call(receiver);
		}
	};

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var problemsAnalysis = function (_ReportSectionsWrappe) {
		_inherits(problemsAnalysis, _ReportSectionsWrappe);

		function problemsAnalysis(props) {
			_classCallCheck(this, problemsAnalysis);

			var _this = _possibleConstructorReturn(this, (problemsAnalysis.__proto__ || Object.getPrototypeOf(problemsAnalysis)).call(this, props));

			_this.state = {
				correctness: 0
			};
			_this.correctnessIncrementer = null;
			return _this;
		}

		_createClass(problemsAnalysis, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;

				var _props$problemAnalysi = this.props.problemAnalysis,
				    id = _props$problemAnalysi.id,
				    outputSimilarityPercentage = _props$problemAnalysi.outputSimilarityPercentage;

				var progreessCircle = document.querySelector('.test-case-' + id + '-progress svg circle');

				progreessCircle.setAttribute('stroke-width', '4.5');

				if (Number(outputSimilarityPercentage) === 0 || !outputSimilarityPercentage) {
					progreessCircle.setAttribute('style', 'stroke:none;');
				}

				outputSimilarityPercentage >= appConstants.question_pass_percentage ? progreessCircle.setAttribute('fill', '#D6FFEC') : progreessCircle.setAttribute('fill', '#FFC9CA');

				this.correctnessIncrementer = setInterval(function () {

					_this2.increaseCorrectness(outputSimilarityPercentage);
				}, 15);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				clearInterval(this.correctnessIncrementer);
				this.correctnessIncrementer = null;
			}
		}, {
			key: 'increaseCorrectness',
			value: function increaseCorrectness(correctness) {
				if (correctness > this.state.correctness) {
					this.setState({ correctness: this.state.correctness + 1 });
				} else {
					clearInterval(this.correctnessIncrementer);
					this.correctnessIncrementer = null;
				}
			}
		}, {
			key: 'renderTestCase',
			value: function renderTestCase(testCases, key, isFirst, isLast) {
				// let label = testCase[0], valueObj = testCase[1];
				var totalTestCases = testCases.length;
				var passedTestCases = testCases.filter(function (testCase) {
					return !!testCase.hasPassed;
				}).length;
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('col-3 py1 px2 center border-top border-bottom border-left', { 'rounded-left': isFirst && !isLast, 'border-right rounded-right': !isFirst && isLast,
							'border-right rounded': isFirst && isLast }) },
					_react2.default.createElement(
						'div',
						{ className: 'test-case-label' },
						key.toUpperCase()
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('mt1 black', { red: passedTestCases !== totalTestCases }) },
						(0, _utils.padZero)(passedTestCases) + ' / ' + (0, _utils.padZero)(totalTestCases)
					)
				);
			}
		}, {
			key: 'renderTestCasesTable',
			value: function renderTestCasesTable() {
				var _this3 = this;

				var _props$problemAnalysi2 = this.props.problemAnalysis.testCases,
				    testCases = _props$problemAnalysi2 === undefined ? [] : _props$problemAnalysi2;

				var _testCaseList = _lodash2.default.groupBy(testCases, 'type');
				var testCaseListKeys = _lodash2.default.keys(_testCaseList);
				return _react2.default.createElement(
					'div',
					{ className: 'flex' },
					_lodash2.default.map(_testCaseList, function (testCases, key) {
						var isFirst = key === testCaseListKeys[0];
						var isLast = key === testCaseListKeys[testCaseListKeys.length - 1];
						return _this3.renderTestCase(testCases, key, isFirst, isLast);
					})
				);
			}
		}, {
			key: 'codeQualityDetail',
			value: function codeQualityDetail() {
				var codeQuality = this.props.problemAnalysis.codeQuality;

				var _codeQuality = _lodash2.default.isObject(codeQuality) && _lodash2.default.isNumber(codeQuality.overallQualityPercentage) ? codeQuality.overallQualityPercentage * 100 : null;
				return _react2.default.createElement(
					'div',
					{ className: 'col-6 px4 py2 border-top' },
					_react2.default.createElement(
						'div',
						{ className: 'pr1 test-case-label mb1' },
						_i18n2.default.t('dk-ui-lib.reports.code_quality')
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('ml2', { 'black': _codeQuality }) },
						_lodash2.default.isNumber(_codeQuality) ? _codeQuality + ' %' : 'N/A'
					)
				);
			}
		}, {
			key: 'getComplexityToolTipMsg',
			value: function getComplexityToolTipMsg(complexity) {
				return _react2.default.createElement(
					'div',
					{ className: 'flex items-center' },
					_react2.default.createElement(
						'div',
						{ className: 'flex items-center mr2' },
						_react2.default.createElement(
							'div',
							null,
							_i18n2.default.t('dk-ui-lib.reports.expected'),
							':'
						),
						_react2.default.createElement(
							'div',
							{ className: 'ml1 brand-color' },
							complexity.expected
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'flex items-center' },
						_react2.default.createElement(
							'div',
							null,
							_i18n2.default.t('dk-ui-lib.reports.obtained'),
							':'
						),
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('ml1', { 'red': !complexity.hasPassed, 'brand-color': complexity.hasPassed }) },
							complexity.obtained
						)
					)
				);
			}
		}, {
			key: 'renderComplexityDetails',
			value: function renderComplexityDetails() {
				var _props$problemAnalysi3 = this.props.problemAnalysis,
				    id = _props$problemAnalysi3.id,
				    _props$problemAnalysi4 = _props$problemAnalysi3.complexity,
				    complexity = _props$problemAnalysi4 === undefined ? {} : _props$problemAnalysi4,
				    complexityEnabled = _props$problemAnalysi3.complexityEnabled;

				var shouldRenderNull = !complexityEnabled || _lodash2.default.isEmpty(complexity) || !_lodash2.default.isObject(complexity);
				return _react2.default.createElement(
					'div',
					{ className: 'col-6 px3 py2 border-right border-top' },
					_react2.default.createElement(
						'div',
						{ className: 'flex items-center mb1' },
						_react2.default.createElement(
							'div',
							{ className: 'field-name-primary' },
							_i18n2.default.t('dk-ui-lib.reports.time_complexity')
						),
						!shouldRenderNull ? _react2.default.createElement(_ToolTipComponent2.default, {
							className: 'clearfix ml2',
							toolTipId: id + ' ' + _i18n2.default.t('dk-ui-lib.reports.time_complexity'),
							message: this.getComplexityToolTipMsg(complexity) }) : null
					),
					_react2.default.createElement(
						'div',
						{ className: 'ml3' },
						shouldRenderNull ? _react2.default.createElement(
							'div',
							null,
							'N/A'
						) : !complexity.hasPassed ? _react2.default.createElement(_wrong2.default, { className: 'svg-icon svg-2x' }) : _react2.default.createElement(_correct2.default, { className: 'svg-icon svg-2x' })
					)
				);
			}
		}, {
			key: 'renderSpeedDetails',
			value: function renderSpeedDetails() {
				var _props$problemAnalysi5 = this.props.problemAnalysis,
				    timeTaken = _props$problemAnalysi5.timeTaken,
				    recommendedTime = _props$problemAnalysi5.recommendedTime;

				return _react2.default.createElement(
					'div',
					{ className: 'col-6 px3 py2 flex justify-between border-right border-top' },
					_react2.default.createElement(
						'div',
						{ className: 'col-1 field-name-primary' },
						_i18n2.default.t('dk-ui-lib.reports.speed')
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-10' },
						_get(problemsAnalysis.prototype.__proto__ || Object.getPrototypeOf(problemsAnalysis.prototype), 'renderSpeedDetail', this).call(this)
					)
				);
			}
		}, {
			key: 'renderCorrectnessDetails',
			value: function renderCorrectnessDetails() {
				var id = this.props.problemAnalysis.id;

				var correctness = this.state.correctness;
				var wasFail = correctness < appConstants.question_pass_percentage;
				return _react2.default.createElement(
					'div',
					{ className: 'clearfix' },
					_react2.default.createElement(
						'div',
						{ className: 'test-case-label' },
						_i18n2.default.t('dk-ui-lib.reports.correctness')
					),
					_react2.default.createElement(
						'div',
						{ className: 'clearfix progress test-case-' + id + '-progress mt2' },
						_react2.default.createElement(
							'div',
							{ className: 'progress-text center h4 black' },
							Math.round(correctness),
							'%'
						),
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)({ '': correctness <= 0 }, 'progress-indicator') },
							_react2.default.createElement(_materialUi.CircularProgress, {
								mode: 'determinate', value: correctness, size: 72, thickness: 5.5,
								color: wasFail ? 'red' : '',
								style: { "transform": "rotate(-90deg)" } })
						)
					)
				);
			}
		}, {
			key: 'renderAnalysisTable',
			value: function renderAnalysisTable() {

				return _react2.default.createElement(
					'div',
					{ className: 'px3 py2' },
					_react2.default.createElement(
						'div',
						{ className: 'px2 flex justify-between' },
						_react2.default.createElement(
							'div',
							{ className: 'col-3' },
							this.renderCorrectnessDetails()
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-9' },
							_react2.default.createElement(
								'div',
								{ className: 'mb2 test-case-label' },
								_i18n2.default.t('dk-ui-lib.reports.test_cases_solved')
							),
							this.renderTestCasesTable()
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    _props$problemAnalysi6 = _props.problemAnalysis,
				    name = _props$problemAnalysi6.name,
				    description = _props$problemAnalysi6.description,
				    id = _props$problemAnalysi6.id,
				    concepts = _props$problemAnalysi6.concepts,
				    index = _props.index;


				return _react2.default.createElement(
					'div',
					{ className: 'clearfix' },
					_get(problemsAnalysis.prototype.__proto__ || Object.getPrototypeOf(problemsAnalysis.prototype), 'renderProblemName', this).call(this, name ? name : 'Programming ' + (index + 1), _i18n2.default.t('dk-ui-lib.reports.problem_info'), concepts, id),
					_react2.default.createElement(
						'div',
						{ className: 'mt2 border rounded' },
						this.renderAnalysisTable(),
						_react2.default.createElement(
							'div',
							{ className: 'flex justify-between' },
							this.renderComplexityDetails(),
							this.codeQualityDetail()
						)
					),
					_react2.default.createElement('hr', { className: 'col-10 mx-auto mt3' })
				);
			}
		}]);

		return problemsAnalysis;
	}(_ReportSectionsWrapperInfo2.default);

	exports.default = problemsAnalysis;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/ProgrammingSecProblemAnalysis.js
// module id = 1195
// module chunks = 0